<script setup>

</script>

<template>
  <div class="view-job-edit-error-page_error-message-container">
    <div class="view-job-edit-error-page_inner-message">
      <i class="fa-regular fa-triangle-exclamation" style="color: var(--info-icon-color);margin-right: 10px"></i>
      <span> This Job is Not Available To Edit</span>
    </div>
    <div class="view-job-edit-error-page_inner-message"
         style="color: #393939; font-size: 13px;">
      The requested job is currently active, so the details cannot be changed .
    </div>
  </div>
</template>

<style scoped lang="scss">

.view-job-edit-error-page {

  &_error-message-container {
    padding-top: 40px;
    height: 100px;
    width: 800px;
    margin: 100px auto;
    background: #fdfdfd;
    border-radius: 20px;
    font-size: 22px;
    color: var(--aqua-blue-definition);
  }

  &_inner-message {
    display: flex;
    align-items: center;
    justify-content: center;
  }

}


</style>
